module.exports = __webpack_public_path__ + "static/media/im.1cf7a64f.svg";